module.exports = __webpack_public_path__ + "img/item_link_packaging@2x.17faee4.webp";